import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import {
  Container, ItemTable, ItemTableCell, TableDivider,
} from './css';
import {
  SummaryTitle,
  Table,
  TableTitle,
  CellLabel,
  CellValue,
  MultilineTableCell,
} from '../css';

const Measurements = ({ data }) => {
  const {
    items,
    referenceNumber,
    poNumber,
    emergencyPhoneNumber,
    erapReferenceNumber,
    erapPhoneNumber,
  } = data;

  return (
    <Container>
      <SummaryTitle>{t('Measurements')}</SummaryTitle>

      {items.map((item, index) => (
        <ItemTable key={index}>
          <TableTitle>
            {t('Item')}
            {' '}
            {index + 1}
          </TableTitle>
          <ItemTableCell column="1">
            <CellLabel>{t('CommodityType')}</CellLabel>
            <CellValue>{item.commodityType}</CellValue>
          </ItemTableCell>
          <ItemTableCell column="2 / 5">
            <CellLabel>{t('Description')}</CellLabel>
            <CellValue>{item.description}</CellValue>
          </ItemTableCell>
          <ItemTableCell>
            <CellLabel>{t('NmfcCode')}</CellLabel>
            <CellValue>{item.nmfc}</CellValue>
          </ItemTableCell>
          <ItemTableCell column="1">
            <CellLabel>{t('SkidQty')}</CellLabel>
            <CellValue>{item.pallets}</CellValue>
          </ItemTableCell>
          <ItemTableCell column="2">
            <CellLabel>{t('PieceQty')}</CellLabel>
            <CellValue>{item.pieces}</CellValue>
          </ItemTableCell>
          <ItemTableCell column="3">
            <CellLabel>{t('Length')}</CellLabel>
            <CellValue>
              {item.length}
              {' '}
              {item.lengthUnitType}
            </CellValue>
          </ItemTableCell>
          <ItemTableCell column="4">
            <CellLabel>{t('Width')}</CellLabel>
            <CellValue>
              {item.width}
              {' '}
              {item.lengthUnitType}
            </CellValue>
          </ItemTableCell>
          <ItemTableCell column="5">
            <CellLabel>{t('Height')}</CellLabel>
            <CellValue>
              {item.height}
              {' '}
              {item.lengthUnitType}
            </CellValue>
          </ItemTableCell>
          <ItemTableCell column="6">
            <CellLabel>{t('TotalWeight')}</CellLabel>
            <CellValue>
              {item.weight}
              {' '}
              {item.weightUnitType}
            </CellValue>
          </ItemTableCell>
          {item.isDangerousGoods && (
          <>
            <TableDivider column="1 / 7" />

            <ItemTableCell column="1">
              <CellLabel>{t('DangerousGoods')}</CellLabel>
              <CellValue>{t('Yes')}</CellValue>
            </ItemTableCell>
            <ItemTableCell>
              <CellLabel>{t('ShippingName')}</CellLabel>
              <CellValue>{item.shippingName}</CellValue>
            </ItemTableCell>
            <ItemTableCell>
              <CellLabel>{t('UNNumber')}</CellLabel>
              <CellValue>{item.unNumber}</CellValue>
            </ItemTableCell>
            <ItemTableCell>
              <CellLabel>{t('TotalQuantity')}</CellLabel>
              <CellValue>{item.quantity}</CellValue>
            </ItemTableCell>
            <ItemTableCell>
              <CellLabel>{t('QuantityUnits')}</CellLabel>
              <CellValue>{item.quantityType}</CellValue>
            </ItemTableCell>
            <ItemTableCell>
              <CellLabel>{t('NumberLabelsNeeded')}</CellLabel>
              <CellValue>{item.numOfPackagesRequiringLabels}</CellValue>
            </ItemTableCell>
          </>
          )}
        </ItemTable>
      ))}
      <Table>
        <MultilineTableCell>
          <CellLabel>{t('TotalNumberOfSkidsInShipment')}</CellLabel>
          <CellValue>{data.pallets}</CellValue>
        </MultilineTableCell>
      </Table>
      <Table>
        <MultilineTableCell>
          <CellLabel>{t('TotalNumberOfPiecesInShipment')}</CellLabel>
          <CellValue>{data.pieces}</CellValue>
        </MultilineTableCell>
      </Table>
      <Table>
        <MultilineTableCell>
          <CellLabel>{t('TotalWeight')}</CellLabel>
          <CellValue>{data.totalWeight}</CellValue>
        </MultilineTableCell>
      </Table>

      {(referenceNumber || poNumber || emergencyPhoneNumber)
        ? (
          <ItemTable>
            <TableTitle>{t('Additional Information')}</TableTitle>
            <ItemTableCell>
              <CellLabel>{t('Reference')}</CellLabel>
              <CellValue>{referenceNumber || 'N/A'}</CellValue>
            </ItemTableCell>
            <ItemTableCell>
              <CellLabel>{t('PurchaseOrder')}</CellLabel>
              <CellValue>{poNumber || 'N/A'}</CellValue>
            </ItemTableCell>
            <ItemTableCell>
              <CellLabel>{t('24hEmergencyNumber')}</CellLabel>
              <CellValue>{emergencyPhoneNumber || 'N/A'}</CellValue>
            </ItemTableCell>
            <ItemTableCell>
              <CellLabel>{t('ERAPReference')}</CellLabel>
              <CellValue>{erapReferenceNumber || 'N/A'}</CellValue>
            </ItemTableCell>
            <ItemTableCell>
              <CellLabel>{t('ERAPPhone')}</CellLabel>
              <CellValue>{erapPhoneNumber || 'N/A'}</CellValue>
            </ItemTableCell>
          </ItemTable>
        )
        : null}

    </Container>
  );
};

Measurements.propTypes = {
  data: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({
      commodityType: PropTypes.string,
      description: PropTypes.string,
      nmfc: PropTypes.string,
      pallets: PropTypes.number,
      pieces: PropTypes.number,
      length: PropTypes.number,
      lengthUnitType: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
      weight: PropTypes.number,
      weightUnitType: PropTypes.string,
      isDangerousGoods: PropTypes.bool,
      shippingName: PropTypes.string,
      unNumber: PropTypes.string,
      quantity: PropTypes.number,
      quantityType: PropTypes.string,
      numOfPackagesRequiringLabels: PropTypes.number,
    })),
    referenceNumber: PropTypes.string,
    poNumber: PropTypes.string,
    emergencyPhoneNumber: PropTypes.string,
    erapReferenceNumber: PropTypes.string,
    erapPhoneNumber: PropTypes.string,
    pallets: PropTypes.number,
    pieces: PropTypes.number,
    totalWeight: PropTypes.string,
  }),
};

export default Measurements;
